import React, { useEffect, useRef, useState } from "react";
import { getRecoil } from "recoil-nexus";
import styled from "styled-components";
import CustomerInfoModal from "../../../components/modal/CustomerInfoModal";
import ApiController from "../../../controller/ApiController";
import LogController from "../../../controller/LogController";
import {
  ContentCardDataType,
  ContentCardDetailType,
} from "../../../controller/MasterController";
import { useToast } from "../../../controller/ToastController";
import { masterStoreState, qrAuthState } from "../../../recoil/auth";
import { langText } from "../../../recoil/lang";
import { getHotelInfoTitle } from "../../../utils/util";

interface StoreCouponProps {
  item: ContentCardDetailType;
  lang: number;
  getCardContent: any;
  cardData: ContentCardDataType;
  setVoucherContent: any;
}

const StoreCouponDetailContent = ({
  item,
  lang,
  getCardContent,
  cardData,
  setVoucherContent,
}: StoreCouponProps) => {
  const showToast = useToast();
  const voucherData = item.voucher;
  const isFirstRender = useRef(true);
  const [inactiveTime, setInactiveTime] = useState(0);
  const [visibleCustomerInfoModal, setVisibleCustomerInfoModal] = useState<{
    visible: boolean;
    method: number;
  }>({
    visible: false,
    method: -1,
  });

  const successVoucher = (number: any, email: any) => {
    if (number || email) {
      sendVoucher(number, email);
    }
  };
  const sendVoucher = async (number: string, email: string) => {
    LogController.click({
      path: "StoreCouponDetailContent",
      params: "coupon",
      params2: voucherData.store_name,
      index: voucherData.voucher_id,
    });

    const response = await ApiController.store.sendVoucher(
      voucherData.voucher_id,
      getRecoil(masterStoreState).store_id,
      getRecoil(qrAuthState).user_token_id,
      number !== "" ? 0 : 1,
      number !== "" ? number : email,
      lang
    );

    if (response.data.success) {
      showToast(langText.send_coupon[lang], "success");
    } else {
      if (response.data.fail_type === 1) {
        showToast(langText.coupon_issued[lang], "error");
      } else if (response.data.fail_type === 2) {
        showToast(langText.coupon_none[lang], "error");
      } else if (response.data.fail_type === 3) {
        showToast(langText.coupon_expired[lang], "error");
      }
    }
    setVisibleCustomerInfoModal({
      ...visibleCustomerInfoModal,
      visible: false,
    });
  };

  useEffect(() => {
    if (!isFirstRender.current) {
      getCardContent(item.card_id, lang);
    } else {
      isFirstRender.current = false;
    }
  }, [lang]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVoucherContent(false);
      setVisibleCustomerInfoModal({
        ...visibleCustomerInfoModal,
        visible: false,
      });
    }, 5 * 60 * 1000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <Style>
      <div>
        <div className="contentHeader">
          <img
            onClick={() => setVoucherContent(false)}
            className="closeIcon"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
            alt="뒤로가기 버튼"
          />
          <h2>{getHotelInfoTitle(cardData, lang)}</h2>
        </div>
        {item.content_data.map((data, index) => (
          <div>
            {data.url && <img width={"100%"} src={`${data.url}`} />}
            <p>{data.content}</p>
          </div>
        ))}
        {item.voucher && (
          <button
            onClick={() =>
              setVisibleCustomerInfoModal({
                ...visibleCustomerInfoModal,
                visible: true,
              })
            }
          >
            {langText.get_coupon[lang]}
          </button>
        )}
        <CustomerInfoModal
          isVisible={visibleCustomerInfoModal}
          setVisible={setVisibleCustomerInfoModal}
          doPayment={successVoucher}
          isVoucher={true}
        />
      </div>
    </Style>
  );
};
export default StoreCouponDetailContent;

const Style = styled.div`
  .contentHeader {
    display: flex;
    align-items: center;
    margin-left: -10px;
    margin-bottom: 30px;
    img {
      margin: 0;
    }
    h2 {
      flex: 1;
    }
  }
  img {
    width: 100%;
    margin-bottom: 12px;
    object-fit: contain;
  }
  h2 {
    font-size: 20px;
    line-height: 30px;
    font-weight: 500;
    text-align: center;
    color: #fff;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 26px;
  }
  .closeIcon {
    width: 30px;
  }
  button {
    margin-top: 50px;
    width: 100%;
    border-radius: 10px;
    background: #4dd2ae;
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    padding: 17px 0;
  }
`;
